import React from 'react';
import { ChevronRightFilled } from '@/components/Icons/ChevronRightFilled';
import { SquareList } from '@/components/Icons/SquareList';
import type { PreschoolEducationPlan } from '@/types/diary';
import { formatDatePeriod } from '@/utils/date';

interface Props {
  plan: PreschoolEducationPlan;
  onClick: () => void;
}

export const PreschoolPlanCard: React.FC<Props> = ({ plan, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex w-full cursor-pointer items-center rounded-xl bg-card p-4 text-left shadow-card transition-colors hover:bg-hover active:bg-on-primary-surface"
  >
    <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-info-surface text-primary">
      <SquareList />
    </span>
    <div className="mx-3 flex min-w-0 flex-1 flex-col">
      <span className="text-subhead-14 truncate text-foreground">
        {plan.name}
      </span>
      <span className="text-body-13 md:text-body-14 mt-0.5 truncate text-muted-foreground">
        {formatDatePeriod(plan.dateFrom, plan.dateTo)}
      </span>
    </div>
    <ChevronRightFilled className="size-4 shrink-0 text-muted-foreground" />
  </button>
);
